// Shopper-facing prices for a product from GET /api/products(/{id}).
//
// The backend never sends other tiers' prices. When the request carried the
// customer's token and their tier (vip / wholesale) has a price on the
// product, `pricing.tier` + `pricing.tier_price` are added for that caller
// only (API_CONTRACT §0). Mirrors utils/pricing.effective_price on the
// server: the sale price wins when it is lower than the caller's price, so
// the displayed price is what the cart will charge.

const positive = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

// `sale_ends_at` (API_CONTRACT §2j): the server stops the sale at that moment;
// a cached list may still carry it for a minute, so a past end = no sale.
export const saleEnded = (product, now = Date.now()) => {
  const end = Date.parse(product?.sale_ends_at || '');
  return Number.isFinite(end) && end <= now;
};

export const productPrices = (product) => {
  const pricing = product?.pricing || {};
  const retail = positive(pricing.retail) ?? positive(product?.price) ?? 0;
  const tierPrice = positive(pricing.tier_price);
  const member = tierPrice ?? retail;
  const sale = saleEnded(product) ? null : positive(pricing.sale);
  const final = sale !== null && sale < member ? sale : member;
  return {
    retail,
    member,
    final,
    tier: tierPrice !== null ? pricing.tier || null : null,
  };
};

// Wishlist items carry `price_at_add` (the effective price when saved).
// True when the product now costs less (half a fils tolerance for rounding).
export const priceDroppedSince = (product, priceAtAdd) => {
  const saved = positive(priceAtAdd);
  if (saved === null) return false;
  const { final } = productPrices(product);
  return final > 0 && final < saved - 0.005;
};

export default productPrices;
